"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.teamFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const Mocks = require("../../../mocks");
const image_factory_1 = require("./image.factory");
const org_details_factory_1 = require("./org-details.factory");
const roster_factory_1 = require("./roster.factory");
const trigger_roster_persona_factory_1 = require("./trigger-roster-persona.factory");
exports.teamFactory = Factory.Sync.makeFactory({
    _links: [],
    abbrev: 'TT',
    banner: image_factory_1.imageFactory.build(),
    created_at: Mocks.dates.date2000,
    customer_team_id: '',
    discarded_at: Mocks.dates.date2000,
    display_status: 'public',
    division_ids: [],
    extended_attributes: [],
    gender: 'coed',
    id: Factory.each(i => uuid_1.v4()),
    logo: image_factory_1.imageFactory.build(),
    name: 'Test Team',
    org_details: org_details_factory_1.orgDetailsFactory.build(),
    originator_id: '5678',
    originator_permissions: null,
    originator_system: 'Ngin',
    originator_type: 'team_instance',
    originator_updated_at: Mocks.dates.date2000,
    primary: true,
    primary_color: '222222',
    program_id: Factory.each(i => uuid_1.v4()),
    program_originator_id: '234',
    program_originator_system: 'Ngin',
    program_originator_type: 'LeagueInstance',
    program_primary_text: null,
    program_secondary_originator_id: null,
    program_secondary_originator_system: null,
    program_secondary_originator_type: null,
    program_secondary_text: null,
    referenced_team_internal_references: [],
    roster_status: 'done',
    rosters: roster_factory_1.rosterFactory.buildList(2),
    secondary_color: '333333',
    sport: null,
    status: 'active',
    team_internal_references: [],
    trigger_roster_personas: trigger_roster_persona_factory_1.triggerRosterPersonaFactory.buildList(2),
    updated_at: Mocks.dates.date2000,
    user_team_roles: 'favorite',
});
